"use client";

import { HomepageHeader } from "@/components/homepage/HomepageHeader";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { usePathname } from "next/navigation";

/**
 * Header shown above public pages for unauthenticated users.
 * Authenticated users get the sidebar layout instead (see ConditionalPublicLayout).
 */
export function ConditionalPublicHeader() {
  const pathname = usePathname();
  const isAuthenticated = useIsAuthenticated();

  // Authenticated users get the sidebar layout, so no public header is needed.
  if (isAuthenticated) return null;

  // Homepage and pricing page render their own HomepageHeader.
  if (pathname === "/" || pathname === "/pricing") return null;

  // TopBar/PublicToolbar are deprecated; use HomepageHeader for remaining
  // unauthenticated public routes so those routes keep public navigation.
  return <HomepageHeader />;
}
